import type {Repository} from '@github-ui/current-repository'
import {commitsByAuthor} from '@github-ui/paths'
import {Box, type BoxProps, Link, Text} from '@primer/react'
import type {Author} from '../commit-attribution-types'
import {AuthorTooltip} from './AuthorTooltip'

export interface AuthorAvatarProps {
  author: Author | undefined
  repo: Repository
  sx?: BoxProps['sx']
  includeTooltip?: boolean
}

/**
 * Renders the author of a commit.
 */
export function AuthorLink({author, repo, sx = {}, includeTooltip = true}: AuthorAvatarProps) {
  if (!author) return null

  return (
    <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', ...sx}} data-testid="author-link">
      {author.login ? (
        <AuthorTooltip author={author} renderTooltip={includeTooltip}>
          <Link
            muted
            href={commitsByAuthor({repo, author: author.login})}
            aria-label={`commits by ${author.login}`}
            sx={{
              fontWeight: 600,
              whiteSpace: 'nowrap',
              color: 'fg.default',
              '&:hover': {color: 'fg.default', textDecoration: 'underline'},
            }}
          >
            {author.login}
          </Link>
        </AuthorTooltip>
      ) : (
        <Text sx={{fontWeight: 600, whiteSpace: 'nowrap', color: 'fg.default'}}>{author.displayName}</Text>
      )}
    </Box>
  )
}

try{ AuthorLink.displayName ||= 'AuthorLink' } catch {}